module.exports = __webpack_public_path__ + "img/rope_ThimbleLock_2.db3066df.png";